<template>
  <section>
    <b-row class="justify-content-between" align-v="start">
      <b-col md="5">
        <b-card>
          <b-form-group label="Select Court" label-for="court">
            <v-select
              ref="courtSelect"
              v-model="currentCourt"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="courtOptions"
              :selectable="option => option && option.type !== 'sci'"
              label="text"
              :filterable="true"
              placeholder="Select Court"
              @input="onCourtSelect"
              @open="onCourtOpen"
            />
          </b-form-group>

          <p v-if="defaultCourt">Default Court: {{ defaultCourt.text }}</p>

          <b-row class="justify-content-between px-1" align-v="center">
            <b-form-checkbox
              :disabled="!currentCourt"
              v-model="isSelected"
              class="custom-control-primary"
              @change="onDefaultSelect"
            >
              Mark Default
            </b-form-checkbox>

            <b-button
              :disabled="!currentCourt"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              class="btn-sm"
              @click="refreshDisplayBoard"
            >
              <feather-icon icon="RefreshCwIcon" class="mr-50" />
              <span class="align-middle">Refresh</span>
            </b-button>
          </b-row>
        </b-card>
      </b-col>

      <!-- RIGHT SIDE TABLE -->
      <b-col md="7">
        <b-overlay
          :show="$store.state.displayboardStore.displayBoardLoading"
          rounded="sm"
          variant="transparent"
          opacity="0.5"
          blur="2px"
        >
          <b-card
            v-if="$store.state.displayboardStore.displayBoardData.length"
            no-body
          >
            <b-table
              responsive="sm"
              :items="$store.state.displayboardStore.displayBoardData"
              :fields="$store.state.displayboardStore.tableFields"
            >
              <template #cell(Court)="data" v-if="currentCourt && currentCourt.cslug === 'hc-punjab'">
                <section>
                  <b-button
                    variant="link"
                    @click="openCasesModel(`display-cases-${data.value}`, data.value)"
                  >
                    {{ data.value }}
                  </b-button>

                  <b-modal
                    :id="`display-cases-${data.value}`"
                    scrollable
                    title="Cases"
                    cancel-title="Close"
                    cancel-variant="outline-secondary"
                  >
                    <b-overlay
                      :show="$store.state.displayboardStore.displayBoardCasesLoading"
                      rounded="sm"
                      variant="transparent"
                      opacity="0.5"
                      blur="2px"
                    ></b-overlay>

                    <b-card-text
                      v-if="
                        !$store.state.displayboardStore.displayBoardCasesLoading &&
                        $store.state.displayboardStore.displayBoardCasesData.length
                      "
                    >
                      <b-card-text
                        v-for="(content, index) in $store.state.displayboardStore.displayBoardCasesData"
                        :key="index"
                      >
                        <b-row>
                          <b-col class="col-12">
                            <h5 v-if="content.case_number" class="font-weight-bold">
                              {{ content.case_number }}
                            </h5>
                            <h6 v-if="content.party_name" class="font-weight-bold">
                              {{ content.party_name }}
                            </h6>

                            <small v-if="content.current_status" class="text-secondary font-italic">
                              Status: {{ content.current_status }}
                            </small>

                            <p v-if="content.judges" class="text-secondary p-0 m-0">
                              Judges: [ {{ content.judges.join(', ') }} ]
                            </p>

                            <p v-if="content.serial_number" class="text-secondary">
                              Sr. No. : {{ content.serial_number }}
                            </p>
                          </b-col>
                        </b-row>

                        <hr class="p-0 m-0" />
                      </b-card-text>
                    </b-card-text>

                    <b-card-text v-else class="m-5"></b-card-text>
                  </b-modal>
                </section>
              </template>

              <template #cell(Progress)="data" v-if="currentCourt && currentCourt.cslug === 'hc-punjab'">
                <div v-if="typeof data.value === 'string' && data.value.includes('http')">
                  <b-link :href="data.value" target="_blank">{{ data.value }}</b-link>
                </div>
                <div v-else>
                  <span>{{ data.value }}</span>
                </div>
              </template>
            </b-table>
          </b-card>

          <b-card
            v-else-if="
              !$store.state.displayboardStore.displayBoardData.length &&
              !$store.state.displayboardStore.displayBoardLoading
            "
            class="text-center"
          >
            <p>Record Not Found!</p>
          </b-card>

          <b-card v-else class="text-center"><p></p></b-card>
        </b-overlay>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BButton,
  BRow,
  BCol,
  BFormGroup,
  BFormCheckbox,
  BCard,
  BCardText,
  BTable,
  BLink,
  BOverlay,
  BSpinner,
} from "bootstrap-vue"
import vSelect from "vue-select"
import Ripple from "vue-ripple-directive"
import moment from "moment"

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    BCard,
    BLink,
    BCardText,
    vSelect,
    BTable,
    BOverlay,
    BSpinner,
  },
  directives: { Ripple },

  data() {
    return {
      currentCourt: null,
      courtOptions: [],
      isSelected: false,
      defaultCourt: null,
      interval: null,
    }
  },

  async beforeMount() {
    try {
      // fetchCourts returns { courtsList, allCourtsFlat } per our store fix
      // const result = await this.$store.dispatch("courtStore/fetchCourts")

      //       console.log("All court options:", result)


      // // Defensive: ensure we have flat array
      // if (result && Array.isArray(result.allCourtsFlat)) {
      //   // store in local component state for v-select
      //   this.courtOptions = result.allCourtsFlat
      // } else if (this.$store.state.courtStore && Array.isArray(this.$store.state.courtStore.allCourtList)) {
      //   // fallback to Vuex state
        // this.courtOptions = this.$store.state.courtStore.allCourtList
          const allCourts = this.$store.state.courtStore.allCourtList || []

  // Apply your filter
        const filteredCourts = allCourts.filter(
          court =>
            court.type === "sci" ||
            (court.type === "hc" && !court.uniqueId.includes("mediation"))
        )

        this.courtOptions = filteredCourts

      // } else {
      //   this.courtOptions = []
      // }
    } catch (e) {
      console.error("Error loading courts for dropdown:", e)
      this.courtOptions = []
    }

    // Restore Default Court from LocalStorage safely
    const userData = (() => {
      try {
        return JSON.parse(localStorage.getItem("userData")) || {}
      } catch {
        return {}
      }
    })()

    if (userData && userData.default_court) {
      const d = userData.default_court
      this.currentCourt = { value: d.value, text: d.label, cslug: d.cslug, type: d.type }
      this.defaultCourt = { ...this.currentCourt }
      this.isSelected = true
      this.refreshDisplayBoard()
    }
  },

  beforeDestroy() {
    clearInterval(this.interval)
  },

  methods: {
    // Clear the internal search when dropdown opens to avoid "no matching options"
    onCourtOpen() {
      // vue-select exposes the search input via $refs.select.search
      // but to be robust, check multiple ways
      const sel = this.$refs.courtSelect
      if (!sel) return

      // vue-select v3: sel.search; older versions might be sel.$refs.search or sel.searchEl
      try {
        if (typeof sel.search === "string") {
          sel.search = "" // clear built-in search
        } else if (sel.$refs && sel.$refs.search) {
          sel.$refs.search.value = ""
        }
      } catch (err) {
        // ignore if not present - this is just a best-effort clear
        // console.debug('could not clear v-select search', err)
      }
    },

    openCasesModel(id, court) {
      if (!this.currentCourt) return
      this.$store.dispatch("displayboardStore/fetchDisplayCasesBoard", {
        value: this.currentCourt.value,
        payload: { court_number: court },
      })
      this.$bvModal.show(id)
    },

    startInterval() {
      const beforeTime = moment("4:59 PM", "LT").format("HH")
      const afterTime = moment("10:00 AM", "LT").format("HH")
      const now = moment().format("HH")
      const day = moment().format("dddd")
      if (day !== "Sunday" && now > afterTime && now < beforeTime) {
        clearInterval(this.interval)
        this.interval = setInterval(() => {
          if (this.currentCourt) {
            this.$store.dispatch("displayboardStore/fetchDisplayBoard", {
              value: this.currentCourt.value,
            })
          }
        }, 60000)
      }
    },

    refreshDisplayBoard() {
      if (!this.currentCourt) return
      this.$store.dispatch("displayboardStore/fetchDisplayBoard", {
        value: this.currentCourt.value,
      })
      this.startInterval()
    },

    onCourtSelect(value) {
      if (!value) return
      // When v-select returns an object, check equality by value property
      this.isSelected = this.defaultCourt && this.defaultCourt.value === value.value

      this.startInterval()
      this.$store.dispatch("displayboardStore/fetchDisplayBoard", {
        value: value.value,
      })
    },

    onDefaultSelect(val) {
      let payload = { default_court: null }

      if (val === true && this.currentCourt) {
        this.defaultCourt = this.currentCourt
        payload = {
          default_court: {
            value: this.currentCourt.value,
            label: this.currentCourt.text,
            cslug: this.currentCourt.cslug,
          },
        }
      } else {
        this.defaultCourt = null
        payload = { default_court: null }
      }

      this.$store.dispatch("settingStore/updateUser", {
        ctx: this,
        payload,
      })
    },
  },
}
</script>

<style scoped>
/* Optional: increase dropdown z-index if overlapped by other elements */
.v-select .vs__dropdown-menu {
  z-index: 2000;
}
</style>
